import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs';
import { indexBy } from 'remeda';
import { request } from '@/core';
import { orderCompetitionsRequest } from '@/api/matches';
import { orderCompetitions, setDailyMatches } from '../actions';
import { selectedDate, currentDailyMatches } from '../selectors';

const orderCompetitionsLocalEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(orderCompetitions.match),
    withLatestFrom(state$),
    map(([{ payload: competitionOrder }, state]) => {
      const date = selectedDate(state);
      const matches = currentDailyMatches(state);
      const competitionOrderMap = indexBy(
        competitionOrder,
        ({ external_id }) => external_id,
      );

      const newMatches =
        matches?.map((match) => ({
          ...match,
          competition: {
            ...match.competition,
            ordinal:
              competitionOrderMap[match.competition.external_id]?.ordinal ??
              null,
          },
        })) || [];

      return setDailyMatches({
        matches: newMatches,
        selectedDate: date,
      });
    }),
  );

const orderCompetitionsEpic: Epic = (action$) =>
  action$.pipe(
    filter(orderCompetitions.match),
    request(
      ({ payload }) => orderCompetitionsRequest(payload),
      orderCompetitions,
    ),
  );

export default combineEpics(orderCompetitionsLocalEpic, orderCompetitionsEpic);
